<template>
  <u-button
    v-bind="buttonAttrs"
    variant="ghost"
    :size="size"
    :color="buttonColor"
    :ui="ui"
  >
    <template v-if="premium">
      <span class="relative inline-flex items-center justify-center before:absolute before:left-1/2 before:top-1/2 before:h-7 before:w-8 before:-translate-x-1/2 before:-translate-y-1/2 before:rounded-lg before:bg-gradient-to-br before:from-heroblue-700 before:to-blue-400 before:shadow-sm before:shadow-charcoal-500/15">
        <u-icon v-if="displayedPremiumIcon" :name="displayedPremiumIcon" class="relative h-5 w-5 text-white" />
        <span
          v-if="!premiumFeatureUnlocked"
          class="absolute -right-3 -top-2.5 flex h-4 w-4 items-center justify-center rounded-full bg-gradient-to-r from-amber-500 to-amber-600 text-white shadow-sm"
        >
          <u-icon name="i-ri-flashlight-fill" class="h-3.5 w-3.5" />
        </span>
      </span>
      <span v-if="$slots.default" class="text-heroblue-700">
        <slot />
      </span>
    </template>
    <template v-else>
      <slot />
    </template>
  </u-button>
</template>

<script setup>
  defineOptions({
    inheritAttrs: false
  });

  const props = defineProps({
    size: {
      type: String,
      default: 'md'
    },
    dark: Boolean,
    iconColor: String,
    premium: Boolean,
    premiumFeatureUnlocked: Boolean
  });

  const attrs = useAttrs();
  const slots = useSlots();
  const displayedPremiumIcon = computed(() => attrs.icon);
  const hasLabel = computed(() => Boolean(slots.default));
  const buttonAttrs = computed(() => {
    if (!props.premium) return attrs;

    const {icon, ...rest} = attrs;
    return rest;
  });
  const buttonColor = computed(() => props.dark ? 'white' : 'charcoal');

  const baseUi = computed(() => ({
    base: 'flex-col flex-center',
    size: {
      md: 'text-xs lg:text-sm whitespace-nowrap',
      lg: 'text-xs lg:text-sm whitespace-nowrap'
    },
    padding: {
      md: 'px-2 sm:px-2',
      lg: 'px-3 sm:px-3.5'
    }
  }));

  const ui = computed(() => {
    const base = {
      ...baseUi.value,
      base: props.premium ? `${baseUi.value.base} group relative ${hasLabel.value ? 'gap-1' : ''}` : baseUi.value.base,
      padding: props.premium && hasLabel.value ? {
        md: 'pb-1',
        lg: 'py-1'
      } : baseUi.value.padding
    };

    if (props.iconColor) {
      base.icon = {
        base: `${props.iconColor}`
      };
    }

    if (props.dark) {
      return {
        ...base,
        color: {
          white: {
            ghost: 'text-white hover:bg-white/10 dark:hover:bg-white/15'
          }
        }
      };
    }

    return {
      ...base,
      color: {
        charcoal: {
          ghost: 'hover:bg-charcoal-200/60'
        }
      }
    };
  });
</script>
